import React from 'react';
import BaseModal from './BaseModal';

const WalletSelectionModal = ({
  isOpen,
  onClose,
  onSelectWallet,
}) => {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Connect Wallet"
      subtitle="Choose your preferred wallet"
      icon="🔗"
      footer={
        <button
          onClick={onClose}
          style={{
            height: '48px',
            width: '100%',
            backgroundColor: 'rgba(55, 65, 81, 0.8)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '12px',
            color: 'white',
            fontSize: '16px',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '8px',
            boxShadow: 'inset 0 2px 4px rgba(0, 0, 0, 0.3), 0 4px 12px rgba(0, 0, 0, 0.2)',
            backdropFilter: 'blur(10px)',
            textShadow: '0 1px 2px rgba(0, 0, 0, 0.5)'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'rgba(55, 65, 81, 0.9)';
            e.target.style.transform = 'translateY(-2px)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'rgba(55, 65, 81, 0.8)';
            e.target.style.transform = 'translateY(0)';
          }}
        >
          Cancel
        </button>
      }
    >
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
      }}>
        {/* MetaMask Option */}
        <button
          onClick={() => onSelectWallet('metamask')}
          style={{
            width: '100%',
            backgroundColor: 'rgba(251, 146, 60, 0.1)',
            border: '1px solid rgba(251, 146, 60, 0.3)',
            borderRadius: '16px',
            padding: '20px',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '20px',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 8px 32px rgba(251, 146, 60, 0.1)'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'rgba(251, 146, 60, 0.2)';
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 12px 40px rgba(251, 146, 60, 0.2)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'rgba(251, 146, 60, 0.1)';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 8px 32px rgba(251, 146, 60, 0.1)';
          }}
        >
          <div style={{
            width: '56px',
            height: '56px',
            backgroundColor: 'rgba(251, 146, 60, 0.2)',
            backdropFilter: 'blur(10px)',
            borderRadius: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid rgba(251, 146, 60, 0.4)',
            boxShadow: '0 4px 12px rgba(251, 146, 60, 0.2)'
          }}>
            <span style={{
              fontSize: '28px',
              filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
            }}>🦊</span>
          </div>
          <div style={{
            flex: 1,
            textAlign: 'left'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: 'white',
              margin: '0 0 6px 0',
              textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
            }}>
              MetaMask
            </h3>
            <p style={{
              fontSize: '14px',
              color: 'rgba(255, 255, 255, 0.7)',
              margin: '0',
              textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
            }}>
              Most popular browser wallet
            </p>
          </div>
          <div style={{
            color: 'rgba(255, 255, 255, 0.6)',
            fontSize: '24px'
          }}>
            →
          </div>
        </button>

        {/* WalletConnect Option */}
        <button
          onClick={() => onSelectWallet('walletconnect')}
          style={{
            width: '100%',
            backgroundColor: 'rgba(59, 130, 246, 0.1)',
            border: '1px solid rgba(59, 130, 246, 0.3)',
            borderRadius: '16px',
            padding: '20px',
            transition: 'all 0.3s ease',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '20px',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 8px 32px rgba(59, 130, 246, 0.1)'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'rgba(59, 130, 246, 0.2)';
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 12px 40px rgba(59, 130, 246, 0.2)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'rgba(59, 130, 246, 0.1)';
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 8px 32px rgba(59, 130, 246, 0.1)';
          }}
        >
          <div style={{
            width: '56px',
            height: '56px',
            backgroundColor: 'rgba(59, 130, 246, 0.2)',
            backdropFilter: 'blur(10px)',
            borderRadius: '16px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid rgba(59, 130, 246, 0.4)',
            boxShadow: '0 4px 12px rgba(59, 130, 246, 0.2)'
          }}>
            <span style={{
              fontSize: '28px',
              filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3))'
            }}>🔷</span>
          </div>
          <div style={{
            flex: 1,
            textAlign: 'left'
          }}>
            <h3 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: 'white',
              margin: '0 0 6px 0',
              textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
            }}>
              WalletConnect
            </h3>
            <p style={{
              fontSize: '14px',
              color: 'rgba(255, 255, 255, 0.7)',
              margin: '0',
              textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
            }}>
              Connect mobile wallets via QR
            </p>
          </div>
          <div style={{
            color: 'rgba(255, 255, 255, 0.6)',
            fontSize: '24px'
          }}>
            →
          </div>
        </button>

        {/* Info Box */}
        <div style={{
          backgroundColor: 'rgba(59, 130, 246, 0.1)',
          backdropFilter: 'blur(10px)',
          borderRadius: '16px',
          border: '1px solid rgba(59, 130, 246, 0.3)',
          padding: '20px',
          display: 'flex',
          alignItems: 'flex-start',
          gap: '16px',
          boxShadow: '0 8px 32px rgba(59, 130, 246, 0.05)'
        }}>
          <div style={{
            marginTop: '2px',
            height: '40px',
            width: '40px',
            backgroundColor: '#3b82f6',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}>
            <span style={{
              fontSize: '16px',
              fontWeight: 'bold',
              color: 'white',
              textShadow: '0 1px 2px rgba(0, 0, 0, 0.5)'
            }}>ℹ️</span>
          </div>
          <div>
            <p style={{
              color: 'white',
              fontWeight: '600',
              fontSize: '16px',
              margin: '0 0 8px 0',
              textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
            }}>
              Security Notice
            </p>
            <p style={{
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: '14px',
              margin: '0',
              textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
            }}>
              Always verify you're on the correct website and double-check transaction details before approving.
            </p>
          </div>
        </div>
      </div>
    </BaseModal>
  );
};

export default WalletSelectionModal;
